<template>
  <div id="content" v-if="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link
              :to="{ name: moduleName }"
              class="btn btn_back"
              v-translate>Seznam
          </router-link>
        </p>
        <p class="buttons">
          <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
        </p>
        <h1 v-translate>Upravit přesměrování aplikace</h1>
      </div>
      <div class="responsiveTabs r-tabs">
        <div class="tabs_content" >
          <basic-info
              :entity="entity"
              :editable="$_updateActionAllowed"
              :isUpdate="true"
          />
        </div>

        <section class="buttons">
          <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam</router-link>
            <input
                v-if="$_updateActionAllowed"
                type="submit"
                :value="'Uložit' | translate"
                :class="['btn', { btn_inactive: !formIsValid }]"
                @click.prevent.stop="submitForm()">
          </p>
        </section>
      </div>
    </form>
  </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import versionRedirects from "./mixins/versionRedirects";
import BasicInfo from "./forms/BasicInfo";

export default {
  name: "VersionRedirectDetail",
  components: {
    BasicInfo
  },
  mixins: [detailActions, versionRedirects],
  data() {
    return {
      entityName: 'versionRedirects'
    }
  },
  created(VersionRedirectService) {
    this.entityService = VersionRedirectService
    this.createdInit();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/versionRedirect/VersionRedirectDetail.vue